import React from 'react';

const X: React.FC<{ className?: string }> = ({ className }) => (
    <svg className={className} viewBox="0 0 32 32">
        <line
            x1="20"
            y1="20"
            x2="12"
            y2="12"
            stroke="currentcolor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <line
            x1="12"
            y1="20"
            x2="20"
            y2="12"
            stroke="currentcolor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

export default X;
